// extracted by mini-css-extract-plugin
export var cardContentContainer = "productsCardFullWidth-module--cardContentContainer--a4cb1";
export var cardDesktopImage = "productsCardFullWidth-module--cardDesktopImage--76751";
export var cardMobileImage = "productsCardFullWidth-module--cardMobileImage--bfb9e";
export var imageContainer = "productsCardFullWidth-module--imageContainer--cf1aa";
export var productsCardFullWidth = "productsCardFullWidth-module--productsCardFullWidth--a0161";
export var styledButton = "productsCardFullWidth-module--styledButton--c92d5";
export var subHeadline = "productsCardFullWidth-module--subHeadline--b15db";